/**
 * OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPage
 *
 * Page component for OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPage
 * Path: /sl/docs/tutorials/beginner/task-manager
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerTaskManagerSLDocScreenView as __OrbDocTutorialsBeginnerTaskManagerSLDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerSLDocScreenView';
import { OrbDocTutorialsBeginnerTaskManagerSLDocAnalyticsView as __OrbDocTutorialsBeginnerTaskManagerSLDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPage(_props: OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Zgradi upravljalnik opravil","description":"Shranjene vrstice, obrazec, ki doda eno, dejanja na vrsticah, ki zaključijo in izbrišejo, in seznam, ki se po vsakem zapisu znova naloži.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/task-manager"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/task-manager"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/task-manager"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerTaskManagerSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerTaskManagerSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerSLOrbDocTutorialsBeginnerTaskManagerSLPage;
